import type { UpdateSailPackagesModification } from '@/root/modules/shared/EditReservation/types'

interface BuildUpdateSailPackagesParams {
  currentSailRefIds: number[]
  newDepartureDate: string
  newDepartureTime: string
  newSailRefId: number
  routeLeg: string
  sailPackage: string
  seqN: number
}

/**
 * Helper for building updateSailPackages modification
 */
export function buildUpdateSailPackagesModification(
  params: BuildUpdateSailPackagesParams
): UpdateSailPackagesModification {
  return {
    __type: 'updateSailPackages',
    sailPackage: params.sailPackage,
    seqN: params.seqN,
    sailRefIds: params.currentSailRefIds,
    updateSailPackage: {
      departureDate: params.newDepartureDate,
      departureTime: params.newDepartureTime,
      routeLeg: params.routeLeg,
      sailRefId: params.newSailRefId,
    },
  }
}
